import { Transaction } from '../accounting/Transaction'
import { Order } from '../sales/Order'
import Delivery from "@/models/delivery/Delivery";

export default class DeliveryAccountStatement {
  static from(json: Record<string, unknown> | DeliveryAccountStatement) {
    const accountStatement = Object.assign(new DeliveryAccountStatement(), json)
    if (accountStatement.delivery)
      accountStatement.delivery = Delivery.from(accountStatement.delivery)
    if (accountStatement.orders)
      accountStatement.orders = accountStatement.orders.map((order) => Order.from(order))
    if (accountStatement.transactions)
      accountStatement.transactions = accountStatement.transactions.map((transaction) =>
        Transaction.from(transaction)
      )
    return accountStatement
  }
  static ENDPOINT = '/reports/delivery/account-statement'

  carrier?: Delivery
  orders: Array<Order> = []
  transactions: Array<Transaction> = []
  printedOn?: string
}
